import Modal from "../Modal";
import OpportunityNewForm from "../../forms/opportunity/OpportunityNewForm";
import {PartnerApi} from "../../../api/partner.api";
import {useEffect, useState} from "react";
import {useAuthStore} from "../../../store/auth.store";
import { useTranslation } from "../../../hooks/useTranslation";

export default function OpportunityExportModal({
                                                   opportunity = null,
                                                   show,
                                                   handleClose,
                                                   title
                                               }) {
    const { t } = useTranslation();
    const token = useAuthStore((state) => state.token);
    const [variants, setVariants] = useState([]);

    const changeVariant = (index) => {
        const variantsNew = [...variants];
        if (!variantsNew.includes(index)) {
            variantsNew.push(index);
        } else {
            variantsNew.splice(variantsNew.indexOf(index), 1);
        }
        setVariants(variantsNew);
    }

    useEffect(() => {
        if (opportunity?.opportunity_variations?.length > 0) {
            opportunity?.opportunity_variations?.map((opportunity_variation, key) => {
                if (opportunity_variation.is_default) {
                    changeVariant(opportunity_variation.variation_id)
                }
            });
        }
    }, []);

    let variantsUrl = "?";
    if (variants.length > 0) {
        variantsUrl += "&variants="+JSON.stringify(variants);
    }

    return (
        <Modal title={title} show={show} handleClose={handleClose}>
            <h4 className={"mb-6"}>{t("opportunities.selectVariantsForExport")}:</h4>
            <div className={"mb-6"}>
                {opportunity?.opportunity_variations?.map((opportunity_variation, key) => (
                    <div key={key} className="mb-4 form-check form-check-sm form-check-custom form-check-solid me-3">
                        <label>
                            <input
                                className="form-check-input me-2"
                                type="checkbox"
                                value="1"
                                checked={variants.includes(opportunity_variation.variation_id)}
                                onChange={() => changeVariant(opportunity_variation.variation_id)}
                            />
                            {opportunity_variation.description}
                            {opportunity_variation.is_default && (
                                <span className="badge badge-primary ms-2">
                                    {t("opportunities.mainVariant")}
                                </span>
                            )}
                        </label>
                    </div>
                ))}
            </div>


            <button
                className="btn btn-success ms-2 mb-2"
                onClick={() =>
                    PartnerApi.download(
                        "/opportunity/" + opportunity.opportunity_id + "/export.pdf"+(variantsUrl!="?"&&variantsUrl),
                        "prilezitost_" + opportunity.opportunity_id + ".pdf",
                        token
                    )
                }
            >
                <i className="ki-duotone ki-document fs-4 cursor-pointer">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>{" "}
                {t("opportunities.exportPdf")}
            </button>
            <button
                className="btn btn-success ms-2 mb-2"
                onClick={() =>
                    PartnerApi.download(
                        "/opportunity/" + opportunity.opportunity_id + "/export.xlsx"+(variantsUrl!="?"&&variantsUrl),
                        "prilezitost_" + opportunity.opportunity_id + ".xlsx",
                        token
                    )
                }
            >
                <i className="ki-duotone ki-document fs-4 cursor-pointer">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>{" "}
                {t("opportunities.exportXlsx")}
            </button>
        </Modal>
    );
};